import { Outlet, Navigate, useNavigate, useLocation } from "react-router-dom";
import { DEFAULT_CURRENCY, EXISTING_COURSE_STATUS, IMAGE_URL, USER_ROLE } from "../../../core/Constant";
import { useEffect, useRef, useState } from "react";
import { Actions } from "../../../core/modules/Actions";
import { connect, useDispatch } from "react-redux";
import { CourseWalkthroughModal, NotificationAlert } from "../../molecule";
import { setTopLevelNavigator } from "../../../core/services/NavigationServicd";
import TermsAndConditionsDialog from "../../molecule/Dialog/TermsAndConditionsDialog";
import _ from "lodash";

const StudentRoutes = ({ getcourseProgress, courseprogress, getNotifications, notifications, currentUser, authCurrentUser, getUserData, acceptTermsAndConditions, getInitialCourseDetails }) => {
  const [unreadNotify, setUnread] = useState([]);
  const [read, setRead] = useState(true);
  const [showTermsDialog, setShowTermsDialog] = useState(false);
  const [showWalkthroughVideo, setShowWalkthroughVideo] = useState(false)
  const [isSeenWalkthroughVideo, setSeenWalthroughVideo] = useState(true)
  const [isFetching, setFetching] = useState(false)

  const [termsAccepted, setTermsAccepted] = useState(() => {
    return localStorage.getItem('termsAccepted') === 'true';
  });
  const navigate = useNavigate();
  const location = useLocation();
  const intervalRef = useRef(null);
  const hasCalledGetUserData = useRef(false);
  const [walkthrough, setWalkthrough] = useState(null);
  
  const dispatch = useDispatch();
  const onNavigate = (path, obj = {}) => {
      if (path) {
          navigate(path, obj);
      }
  }

  useEffect(()=>{
    if(walkthrough?.videoUrl){
     setShowWalkthroughVideo(true)
    } else {
     setShowWalkthroughVideo(false)
    }
  },[walkthrough])

  useEffect(() => {
      intervalRef.current = onNavigate;
      setTopLevelNavigator(intervalRef);
  }, [navigate]);


  useEffect(() => {
    getcourseProgress();
  }, [location, getcourseProgress]);


  useEffect(() => {
    const userId = parseInt(localStorage.getItem("userId"));
    if (userId) {
      getNotifications(userId);
    }
  }, [location, getNotifications]); 


  useEffect(() => {
    const unread = notifications.filter((notification) => notification.is_read === 0);
    setUnread(unread);
  }, [notifications]);

  useEffect(() => {
    const firstCourse = courseprogress[0] || {};
    if (firstCourse?.course_id) {
      localStorage.setItem("firstcourse", firstCourse.course_id);
    }
  }, [courseprogress]);

 
  useEffect(() => {
    // Check localStorage first - if terms are already accepted locally, don't override
    const localTermsAccepted = localStorage.getItem('termsAccepted') === 'true';
    if (localTermsAccepted && isSeenWalkthroughVideo) {
      setTermsAccepted(true);
      setShowTermsDialog(false);
      return; // Exit early if terms are already accepted locally
    }
    
    if (authCurrentUser && Object.keys(authCurrentUser).length > 0) {
      const loginTermsAccepted = _.get(authCurrentUser, 'terms_accepted', false);
      
      if (loginTermsAccepted) {
        setTermsAccepted(true);
        setShowTermsDialog(false);
        if (!hasCalledGetUserData.current) {
          console.log('Calling getUserData from login response (terms_accepted: true)');
          getUserData();
          hasCalledGetUserData.current = true;
        }
      } else {
        setShowTermsDialog(true);
        setTermsAccepted(false);
      }
    } 
    else if (currentUser && Object.keys(currentUser).length > 0) {
      const backendTermsAccepted = _.get(currentUser, 'terms_accepted', false) || 
                                    _.get(currentUser, 'termsAccepted', false);
      
      if (backendTermsAccepted) {
        setTermsAccepted(true);
        setShowTermsDialog(false);
      } else {
        setShowTermsDialog(true);
        setTermsAccepted(false);
      }
    } 
    else {
      setShowTermsDialog(true);
      setTermsAccepted(false);
    }
  }, [authCurrentUser, currentUser, getUserData, isSeenWalkthroughVideo]);

  useEffect(() => {
    if (termsAccepted) {
      if (!hasCalledGetUserData.current) {
        console.log('Calling getUserData because terms are accepted, termsAccepted:', termsAccepted);
        getUserData();
        hasCalledGetUserData.current = true;
      }
    } else {
      hasCalledGetUserData.current = false;
    }
  }, [termsAccepted, getUserData]);

  const closeWalkthrough = () => {
    if (walkthrough?.courseId) {
        dispatch(Actions.course.markWalkthroughAsSeen(walkthrough.courseId));
    }
    localStorage.removeItem("pendingEnrollmentCourseId");
    setWalkthrough(null);
    setSeenWalthroughVideo(true)
  };

  const finishWalkthrough = () => {
      if (walkthrough?.courseId) {
        dispatch(Actions.course.markWalkthroughAsSeen(walkthrough.courseId));
      }
      localStorage.removeItem("pendingEnrollmentCourseId");
      setWalkthrough(null);
      setSeenWalthroughVideo(true)
  };

  const callDetailsFetchAPI = ()=>{
    setFetching(true)
    const enrolledCourseId = localStorage.getItem("pendingEnrollmentCourseId");
    let adminStudentCourse = localStorage.getItem("adminStudentWalkthrough")
    adminStudentCourse = JSON?.parse(adminStudentCourse)

    if(enrolledCourseId){
      getInitialCourseDetails(DEFAULT_CURRENCY).then((response) => {
          const responseData = response?.data ?? response;
          const courses = responseData?.otherCourses || responseData?.topBannerCourses || [];
          const enrolledCourse = courses.find(
            (course) => String(course?.id || course?.course_id) === String(enrolledCourseId)
          );
          const video = enrolledCourse?.walkthrough_video_url || enrolledCourse?.walkthrough_video;
    
          if (!enrolledCourse || !video) {
            setShowTermsDialog(false);
            setTermsAccepted(true);
            setSeenWalthroughVideo(true)
            setFetching(true)
            return
          }
          
          if(video && (enrolledCourse?.seen_walkthrough_video === false || enrolledCourse?.seen_walkthrough_video === "false")  ){
            setWalkthrough({
            courseId: enrolledCourse.id || enrolledCourse.course_id,
            courseName: enrolledCourse.name || enrolledCourse.course_name,
            videoUrl: video.startsWith("http") ? video : IMAGE_URL + video,
            seenWalkthroughVideo: enrolledCourse.seen_walkthrough_video,
            isMandatory: enrolledCourse.is_walkthrough_video_mandatory === true ||
              Number(enrolledCourse.is_walkthrough_video_mandatory) === EXISTING_COURSE_STATUS.FREE,
          });
           setFetching(false)
          } else {
             setShowTermsDialog(false);
             setTermsAccepted(true);
             setSeenWalthroughVideo(true)
             setFetching(false)
          }
      });
      return
    } else if(adminStudentCourse){
      const video = adminStudentCourse?.walkthrough_video_url || adminStudentCourse?.walkthrough_video;
      if(video && (adminStudentCourse?.seen_walkthrough_video === 0)){
        setWalkthrough({
            courseId: adminStudentCourse?.course_id || "",
            courseName: adminStudentCourse?.name || "",
            videoUrl: video.startsWith("http") ? video : IMAGE_URL + video,
            seenWalkthroughVideo: adminStudentCourse?.seen_walkthrough_video === 1,
            isMandatory: adminStudentCourse?.is_walkthrough_video_mandatory === 1
          });
          setFetching(false)
       } else {
         setShowTermsDialog(false);
         setTermsAccepted(true);
         setSeenWalthroughVideo(true)
         setFetching(false)
      }
    } else {
      setShowTermsDialog(false);
      setTermsAccepted(true);
      setSeenWalthroughVideo(true)
      setFetching(false)
      return;
    }
  }

  const handleAcceptTerms = async () => {
    setSeenWalthroughVideo(false)
    const userId = localStorage.getItem("userId");
    if (userId) {
      dispatch(acceptTermsAndConditions({ user_id: userId }));
      callDetailsFetchAPI()
      localStorage.setItem('termsAccepted', 'true');
      localStorage.setItem('termsAcceptedDate', new Date().toISOString());
    } else {
      setTermsAccepted(true);
      setShowTermsDialog(false);
      localStorage.setItem('termsAccepted', 'true');
    }
  };

  const handleClose = () => {
    setRead(false);
    navigate("/StudentNotification");
  };

  const user = parseInt(localStorage.getItem("userType"));
  
  return (
    <>
      <div>
        {termsAccepted && (user === USER_ROLE.student ? <Outlet /> : <Navigate to="*" />)}
        {unreadNotify.length > 0 && termsAccepted && (
          <NotificationAlert
            handleClose={handleClose}
            isread={read}
            data={{
              title: "Notification",
              message: unreadNotify.length > 1 ? `You have ${unreadNotify.length} Unread Notifications` : "You have Unread Notification",
            }}
          />
        )}
      </div>
      
      {/* Show terms dialog when terms not accepted */}
      {!termsAccepted && (
        <TermsAndConditionsDialog
          open={showTermsDialog}
          isLoading={isFetching}
          onAccept={handleAcceptTerms}
          onClose={() => {}} // Prevent closing without acceptance
        />
      )}
      {walkthrough && walkthrough?.videoUrl &&
        (walkthrough.seenWalkthroughVideo === false || walkthrough.seenWalkthroughVideo === "false") && (
        <CourseWalkthroughModal
          open={showWalkthroughVideo}
          videoUrl={walkthrough?.videoUrl}
          courseName={walkthrough?.courseName}
          isMandatory={walkthrough?.isMandatory}
          onClose={closeWalkthrough}
          onEnded={finishWalkthrough}
        />
      )}
    </>
  );
};

export default connect(
  (state) => ({
    courseprogress: state.home.get("courseprogress"),
    notifications: state.notification.get("notifications"),
    currentUser: state.profile.get("currentUser"),
    authCurrentUser: state.auth.get("currentUser"), // Login response data
  }),
  {
    getcourseProgress: Actions.home.getcourseProgress,
    getNotifications: Actions.notification.getNotifications,
    getUserData: Actions.profile.getUserData,
    acceptTermsAndConditions: Actions.profile.acceptTermsAndConditions,
    getInitialCourseDetails: Actions.guest.getInitialCourseDetails,
  }
)(StudentRoutes);
 